import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    fullScreen: {
      type: Boolean
    },
    show: {
      type: Boolean
    },
    locationStrategy: null
  },
  setup(__props) {
    const props = __props;
    return {
      __sfc: true,
      props
    };
  }
});